module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTY3NzYgNEgxLjA2MzA4QzAuNDI1MjM0IDQgMCA0LjQgMCA1VjE1QzAgMTUuNiAwLjQyNTIzNCAxNiAxLjA2MzA4IDE2SDkuNTY3NzZDMTAuMjA1NiAxNiAxMC42MzA4IDE1LjYgMTAuNjMwOCAxNVY1QzEwLjYzMDggNC40IDEwLjIwNTYgNCA5LjU2Nzc2IDRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTMuODIwMyAwSDMuMTg5NDVWMkgxMi43NTcyVjEzSDE0Ljg4MzRWMUMxNC44ODM0IDAuNCAxNC40NTgxIDAgMTMuODIwMyAwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/clone.svg
// module id = 1446
// module chunks = 180